import {
  Box,
  Disclosure,
  DisclosureContent,
  DisclosureTrigger,
  Field,
  Flex,
} from '@optiaxiom/react';

import { MarkdownText } from '@frontend/components/MarkdownText';
import { useOptimizelyUser } from '@frontend/hooks';

type TokenUsage = {
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  thinking_tokens?: number;
  cached_tokens?: number;
};

type TokenUsageSectionProps = {
  tokenUsage?: TokenUsage;
};

export function TokenUsageSection({ tokenUsage }: TokenUsageSectionProps) {
  const { isOptimizelyUser } = useOptimizelyUser();

  if (!isOptimizelyUser || !tokenUsage) {
    return null;
  }

  return (
    <Disclosure>
      <DisclosureTrigger>
        <Field label="Token Usage" info="Token consumption details for this execution" />
      </DisclosureTrigger>
      <DisclosureContent>
        <Flex flexDirection="column" gap="16" px="16">
          <Field label="Token Consumption">
            <Box border="1" borderColor="border.default" rounded="md">
              <Box bg="bg.default" p="12">
                <MarkdownText
                  text={(() => {
                    const rows = [
                      `| **Input Tokens** | ${tokenUsage?.input_tokens?.toLocaleString()} |`,
                      `| **Output Tokens** | ${tokenUsage?.output_tokens?.toLocaleString()} |`,
                    ];

                    if ((tokenUsage?.thinking_tokens ?? 0) > 0) {
                      rows.push(
                        `| **Thinking Tokens** | ${tokenUsage?.thinking_tokens?.toLocaleString()} |`
                      );
                    }

                    if ((tokenUsage?.cached_tokens ?? 0) > 0) {
                      rows.push(
                        `| **Cached Tokens** | ${tokenUsage?.cached_tokens?.toLocaleString()} |`
                      );
                    }

                    rows.push(
                      `| **Total Tokens** | ${tokenUsage?.total_tokens?.toLocaleString()} |`
                    );

                    return `| Metric | Count |\n|--------|-------|\n${rows.join('\n')}`;
                  })()}
                />
              </Box>
            </Box>
          </Field>
        </Flex>
      </DisclosureContent>
    </Disclosure>
  );
}
